<template>
<body >
    
    <!-- <enviarmensaje v-if="displayPopupMessages" v-bind:listaPacientes="listaPacientes"></enviarmensaje> -->
    
    <div class="content" >
        <!--div module 2-->
        <!-- <div  v-if="Mensaje=='Panel de control'"> -->
            <!-- "[Mensaje=='Panel' ? {} : {styleB}]" -->
        <div class='grid-container' style="backgroundColor:white;vertical-align: middle; display: block" v-if="levelApp === 1" >
            <div class = "Area 1">
                <graficos v-if="datosListosMod1" :series="seriesMod1" :datacollection="datacollectionMod1"></graficos>
                <div id="cajaMensajeDinamico">
                    <h4 id="mensajeDinamico"> Pacientes de <a style="font-weight: bolder;"> {{this.showPrograma}}</a> en un periodo de <a style="font-weight: bolder;"> {{this.showCantidad}} {{this.showTiempo}} </a> que se encuentran <a style="font-weight: bolder ;"> {{this.showEstado}}</a> de actividades</h4>
                </div> 
            </div>
            <div class = "Area 2">
                <graficos v-if="datosListosMod2" :series="seriesMod2" :datacollection="datacollectionMod2"></graficos>
                
                <div id="cajaMensajeDinamico2" >   
                 <!--<div><img src = "../assets/Neumobot-.png" style="height:80px;display:inline-block;float:left"></div> -->
                 <h4  id="mensajeDinamico"> Pacientes gestionados en un periodo de <a style="font-weight: bolder;"> {{this.showCantidad_gestion}}  {{this.showTiempo_gestion}}</a></h4>
                 </div>
            </div>
        </div>
    </div>
    <popup-bar-selected v-if="displayPopup" v-bind:dataPopup="dataPopup" :barWidth="120"></popup-bar-selected>
    <loading v-if="displayLoading"></loading>
</body>
</template>

<script>
import metodos_comunes from '../js/metodos_comunes'
import Graficos from '../components/Graficos'
import PopupBarSelected from '../components/PopupBarSelected'
// import Enviarmensaje from '../components/Enviar_mensaje'
import Loading from '../components/Loading'
import { serverBus } from '../main'
import axios from '../apiService/config/axios.js'
// import variableEntorno from '../../static/config.json'
import graficos,{ contruyeDataCollection } from '../js/graficos'
import json_test_mod1 from '../../static/jsonTestMod1.json'
import json_test_mod2 from '../../static/jsonTestMod2.json'

let jsonClient;

var valorPrueba1 = 0
var valorPrueba2 = 0
// This function cancel the default menu that appear with right click
window.oncontextmenu = function (e)
{
  //setTimeout(() => serverBus.$emit('checkClickRightMod1',"true"));
  //setTimeout(() => serverBus.$emit('checkClickRightMod4',"true"));
  return true;
}
export default {
    data (){
        return{
            // urls
            // Endpoints module 1 y 2 (para generar los graficos de barras)
            endpointMod1:'', // Trae todos los datos para graficar el modulo 1 (registro, barras)
            endpointNotRegister:'', // Trae todos los datos para graficar el modulo 2 (gestion barras, sin registrados)
            endpointRegister:'',// Trae todos los datos para graficar el modulo 2 (gestion barras, con registrados)
            // Enpoints list patients
            listPatientsMod2_notRegister:'',// Trae la lista de pacientes (SIN REGISTRO), gestionados o no gestionados, recibe como parametros: cantidad, filtro_tiempo, programa, filtro_tiempo_gestion, cantidad_gestion, pacientes (gestionados, no_gestionados), canal
            lista_pacientes_mod1_registro:'',// Trae la lista de pacientes para el modulo 1 (registro), recibe como parametros: cantidad, filtro_tiempo, filtro (registrados, no registrados), programa 
            listPatientsMod2_register:'',// Trae la lista de pacientes (CON REGISTRO), gestionados o no gestionados, recibe como parametros: cantidad, filtro_tiempo, programa, filtro_tiempo_gestion, cantidad_gestion, pacientes (gestionados, no_gestionados), canal

            //Mensaje:false,
            levelApp:1,
            displayPopup:false,
            displayPopupMessages:false,
            displayLoading:false,
            dataPopup:{},
            listaPacientes:{},
            jsonInfo:{},
            showTiempo:'',
            showCantidad:'',
            showPrograma:'',
            showCantidad_gestion:'',
            showEstado:'',
            showTiempo_gestion:'',
            enpointControl:0,
            programSelected:"p_rhb",   // Program by default
            EstiloEnChat:{
                display:'block',
                float:'none',
            },
            datacollectionMod1: {
            },
            datacollectionMod2: {
            },
            datosListosMod1:false,
            datosListosMod2:false,
            seriesMod1:[],
            seriesMod2:[]
        }
    },
    computed: {
        datacollectionModulo1(){
            console.log("cambioDataCollectionModulo1")
            return this.$store.getters.getDataCollectionCambio1
        },
        datacollectionModulo2(){
            console.log("cambioDataCollectionModulo2")
            return this.$store.getters.getDataCollectionCambio2
        },
        cambioJsonRegistro(){
            console.log("cambioModulo1")
            try{
                this.consultaEndpoint("moduloGestion_1", this.$store.getters.getJsonRegistro)
            }catch(err){

            }
            return this.$store.getters.getJsonRegistroCambio
        },
        cambioJsonGestion(){
            console.log("cambioModulo2")
            try{
                this.consultaEndpoint("moduloGestion_2", this.$store.getters.getJsonGestion)
            }catch(err){

            }
            return this.$store.getters.getJsonGestionCambio
        },
    },
    watch: {
        datacollectionModulo1(){
        },
        datacollectionModulo2(){
        },
        cambioJsonRegistro(){
        },
        cambioJsonGestion(){
        }
    },
    components:{
        Graficos,
        PopupBarSelected,
        // Enviarmensaje,
        Loading
    },
    beforeMount(){
        //this.getIndicatorsModule1(endpointMod1);
        this.initDataCollections()
    },
    created(){

        let json = 
        {
            cantidad: "30",
            filtro_tiempo: "dias" 
        }
        var jsonClient = {
            programa:"p_rhb",
            estado:"no_registrado",
            filtro_tiempo:"dias",
            cantidad:"30",
            filtro_tiempo_gestion:"dias",
            cantidad_gestion:"30"
        }

        this.$store.dispatch('setJsonRegistro', json)
        this.$store.dispatch('setJsonGestion', jsonClient)
        
        console.log("response_control_modulo0",this.$store)
        //this.datacollectionMod1 = {labels:[],datasets: []}
        //this.datacollectionMod1.labels = ["1","2","3"]
        
        //axios.get("static/config.json").then(response => {

        this.endpointMod1 = '/controlador_datos/programas/programas_x_tiempo'
        this.endpointNotRegister = "/controlador_datos/programas/rhb_no_contactos_gestionados"
        this.endpointRegister = '/controlador_datos/programas/rhb_contactos_gestionados'
        this.listPatientsMod2_notRegister = "/controlador_datos/programas/pac_rhb_no_contactos_gestionados"
        this.lista_pacientes_mod1_registro = "/controlador_datos/programas/pac_programas_x_tiempo"
        this.listPatientsMod2_register = "/controlador_datos/programas/pac_rhb_contactos_gestionados"
        //});
        // Funciones tipo serverBus, se pueden llamar desde otros componentes, para transferencia de datos.
        /**
         * Funcion Mensaje, mensaje de inicion enviado desde patientRegister.vue
         */
        serverBus.$on('Mensaje', (Mensaje) =>{
            this.Mensaje=false
            console.log("Mensajerecibido",this.Mensaje)

        }),

        /**
         * Consulta lista de pacientes para enviar hacia el chat-box(para enviar el mensaje) y para cargarlos en el panel lateral de historia clinica
         * @param {*} Mensaje Contiene json para consulta (pacientes, canal, estado(registrados, no-registrados))
         */
        serverBus.$on('listaDePacientes', (Mensaje) =>{
            let endpoint;
            let json = Mensaje[2];
            json["pacientes"]=Mensaje[0]
            json["canal"]=Mensaje[1]
            
            if(json["estado"]=="registrado"){
                endpoint = this.listPatientsMod2_register
            }else{
                endpoint = this.listPatientsMod2_notRegister
            }
            console.log("listadelospacientes", json, endpoint)
            axios.post(endpoint,
                json)
                .then(Response => {
                    console.log("jsonClient",Response)
                    this.listaPacientes = Response.data.data.modulo_data
                    //Envia lista de pacientes al chat, para cargar la variable que enviara el mensaje
                    setTimeout(() => serverBus.$emit('cargarListaDePacientes',this.listaPacientes));
                    
                    setTimeout(() => serverBus.$emit('lista_pacientes_chat',this.listaPacientes));
                })
                .catch(error => console.log("error",error)) 
        }),
        /**
         * Carga pacientes para modulo de registro, los envia al chat para enviar el mensaje y al panel lateral de historia clinica.
         * @param {*} json Contiene json para consulta (filtro(registrados, no-registrados))
         */
        serverBus.$on('listaDePacientes_registro', (json) =>{
            
            let endpoint = this.lista_pacientes_mod1_registro;
            
            console.log("listadelospacientes_registro", json, endpoint)
            axios.post(endpoint,
                json)
                .then(Response => {
                    console.log("jsonClient_registro",Response)
                    this.listaPacientes = Response.data.data.modulo_data
                    setTimeout(() => serverBus.$emit('cargarListaDePacientes',this.listaPacientes));
                    
                    //Envia lista de pacientes al chat, para cargar la variable que enviara el mensaje
                    setTimeout(() => serverBus.$emit('lista_pacientes_chat',this.listaPacientes));
                })
                .catch(error => console.log("error",error)) 
        }),
        /**
         * Actualiza la configuracion global de las variables de consulta, programa, estado, filtro_tiempo, etc
         */
        serverBus.$on('globalConfiguration', (refresh) =>{
            jsonClient = refresh;
            this.showCantidad=jsonClient["cantidad"]
            this.showPrograma=metodos_comunes.getTextFromID(jsonClient["programa"])
            this.showCantidad_gestion=jsonClient["cantidad_gestion"]
            this.showEstado=metodos_comunes.getTextFromID(jsonClient["estado"])
            this.showTiempo=refresh["filtro_tiempo"]
            this.showTiempo_gestion=jsonClient["filtro_tiempo_gestion"]
        }),
        /**
         * Cierra popup de envio de mensajes
         */
        serverBus.$on('response_message', (response_message) =>{
            this.displayPopupMessages = false;
            this.lista_pacientes = [];
        })

        this.firabaseEvents();
    },
    beforeDestroy(){
      serverBus.$off('listaDePacientes_registro')
      serverBus.$off('listaDePacientes')
    },
    mounted(){
        
    },
    beforeDestroy(){
        serverBus.$off('Mensaje')
        serverBus.$off('listaDePacientes')
        serverBus.$off('listaDePacientes_registro')
        serverBus.$off('globalConfiguration')
        serverBus.$off('resetModule2')
        serverBus.$off('updateModules')
        serverBus.$off('response_message')
        serverBus.$off('displayModule')
        serverBus.$off('displayPopup')
        serverBus.$off('closePopup')
    },

    methods:{
        initDataCollections(){
            this.datacollectionMod1 = {
            },
            this.datacollectionMod2 = {
            }
        },

        consultaEndpoint(modulo,json){
            var endpoint='';
            if(modulo=="moduloGestion_1"){
                endpoint = this.endpointMod1
            }else if(modulo=="moduloGestion_2"){
                endpoint = this.endpointNotRegister
            }
            console.log("displayModule", endpoint, json)
            this.obtieneDatosParaGraficar(endpoint, json, modulo)
        },

        /**
         * Funcion que inicializa firebase con las crendenciales
         */
        firabaseEvents:function(){
            let config = {
                /*
                "type": "service_account",
                "project_id": "neumopush",
                "private_key_id": "c56ec46a1d07efd6b22c09c282a98fea220c498a",
                "private_key": "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDDcxQ2PT6W2ii2\nlxEIZIO401aGDkf2ZZHfLm0siMKF8LlDuVCtJQ6Zi0hUYL5OrxbnoEbJBl5RcTS4\nzkDZKmW5l7k//yNfl1ox61lu5g/bYU0IqPFux6HzHyQiRUJ29xVHzhYMC6f4QeF5\n8ufZJoFQxjsggpxcPo0kBN6tTwcyrK2+zSEyBfG5uHS/Z0laHClVezRzOD6KfO/c\nZ/bj6YCRJ7mLchpWz6wuMhnYCgD/L4s3PT0RaOijuIAZbD7s9OJi9bifwyFua+j2\nhS9A0gIky/CgOe7STJNxUNlSeGsV+DL753N/XjEMgrKUVojUlkgbiBWfe6ehA7Pe\n9KhDUtJrAgMBAAECggEAR37hvmOR8THVodFKCEVoj+QzKu+vcFlATqFXi2ptqfxg\ncP8pnWTIXe9+4mrPQs42tT1Cl4euWeFs9Utxml8xff4b5Gaq5G1jr44VlYUv+MKz\noL7YLnt1aQ+TsrueMBF7Zdxj4T0kUSKcXfU2zY8Rz9/rwh01IGM7Uxk68a/OhMDV\nWJdAgguVbp43o5n+nw+oHPDB2VFrxCeKOkMxMNrCpC+/iVMR3Y7ajG6ma+d8wbjk\nDYrbIYQ2f7MRJ73/CqPXcaSPial5sNrk78zBF+ndLtQ+o7Ajkt88Z3+9jxjRymXC\nfcmqE4Q5V4Xz1ZQQRe9vTzpxlm9HTVev0uRnc/S11QKBgQDg1Bxau+T2wran2Mdo\nonebN/1q9Q6pPC6fBryx4OygLsyU/Xyw/aGcvhtcDRDWmNOOulk6sd95RTvJkn0q\nL6+iT2Xe67vJCfGvMsWSQNeqXH1d00ukWMB3gq1VCmdc0nc+zYOC26tTT209C1aY\nHSWGnAgUkk6eNq3fkI23zBdKzwKBgQDejDY6a8UOGTgedEXYaK7taf+g8ieAAcPK\nbVCNHhGirebmanJAV3rOJDCICtIePXxnNCfDIaKwfhr5gSDotIwmJjeV73REYgPg\n5ttypFtw6t+1xJEN9FtgAT0zUbXn1b6iQA/DXxzz66OFgSQ6LzJ3Pl/u7nHbXlqq\nNf/YhrF1pQKBgQCCT05z5I2r3GWD2WiSpAARDh2qvYiW3FPlRkFeFBDyMs3O2TFJ\nYGgociNncgc9amzMQAPxuiDdqBwkE+zJ48O3nq9bymQX/NSBCDttLnoRuvPKyun/\nwpUjb7FJJfOM4EvPMcy0rt+ZNOMKy6SQG+yhHZStX7ODjguvFZieXANwDwKBgGox\nLY8i7ZyUnBqsEMf6672N3tTFt+N09CAbmVw9BN1DbfJ0yJ+7HnZO/nlr8GdNn5b/\nZBnQavkcs3JrE3D29gkeI1gAMtKOkps2jXBezONMsALkEPM/rnpZHQLn8oz1iUmS\nl/L5567cueJyhP7elo4fzVcNoHa0xz6BFdwUKYmhAoGBAMIeis/3MhYwNU8sPi2j\n8JVEUkntGY2mLeuDFrej2WFOGNYsuCUkigsGRCSl+Ewxr7dPY87zCIPM7AHxwfsR\n6Q8TquP5oC59WMy/YVv5A3HErK0I52nlUSMNj83VXz9v8jqPuSfRaGJKi71ShtoV\nMfM2nkhj5BJ/RO+SE42dUDp9\n-----END PRIVATE KEY-----\n",
                "client_email": "firebase-adminsdk-gz7mr@neumopush.iam.gserviceaccount.com",
                "client_id": "100995347222836236548",
                "auth_uri": "https://accounts.google.com/o/oauth2/auth",
                "token_uri": "https://oauth2.googleapis.com/token",
                "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
                "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-gz7mr%40neumopush.iam.gserviceaccount.com",
                "databaseURL": "https://neumopush.firebaseio.com",
                "storageBucket": "neumopush.appspot.com",
                */

                "type": "service_account",
                "project_id": "neumomeddesarrollo",
                "private_key_id": "57c3999e0dc432ce7fe5d9f96966fe4d627f22bb",
                "private_key": "-----BEGIN PRIVATE KEY-----\nMIIEvwIBADANBgkqhkiG9w0BAQEFAASCBKkwggSlAgEAAoIBAQCoFEUZW399QD8A\nUm+4EZAUiZXg9ZQ9PCJ5FmFjWE49kLu+Cgzk/llP/esw3+Ewi6/jdSAc1EbuF+gi\nRbSV9QTGO7QdTcKotcDp3baRH3kn0L7dil6HeDI6tpdn2ZRK8Nx3mNwVKDLDajNj\n/fLwAxiAqddKdHntEPz2IOZl81fyYMl3uC2EeooCMJOdhTiFiMe95hVFo76MOGak\nl8jg1OBCll0WFxomaGL6BApUBnVTrAXgcU0qiQbnLs9COjfVP3j071OU3p3QAvUQ\nMnwme21jylBb+/0fyVOMZDrXfMVpFk5oeSbhf4B2YJV8yRaNBR5mKtunvRcBkUD+\neZniYmRhAgMBAAECggEAB45ROKmLCLw8FNFv56lE9hJlFi3OFCZlWZaQqlrWehit\nAvcgUyVOyix836ep38EA10etOdSOa37QQwWpj436MOfvUfusXQGeNnk+z0V4IKrH\nAM47D4mfDvIFSpAuxSNwstDwsGQMK6olHSk1/BWUivivpq+HqWlQiOdL2kCTNyBx\nYXpM2K+uEQpiwXg5e5RYFADwFgQ2skIczb8hO5pLWvdNSy1zWg5MBc+DbBWEbjqC\nPAeXjPvJvYX/HZ4ZEssnq+WFa5Z7MJawA+ko18pvxbL7Zw3/U6V1IRSFS3JSbDA4\nQoa9GhrbCapcgELDUWmZTXt6VVQ9Tk4Ze9LiPkUZ8QKBgQDlY2XYL1Gn23RVqeoQ\nQCeWiR9oWJ+h/tC4dgqNEzF8L+HJbkB0jIMTZTg2DxaYv7DR9Yrhq+Tl9rp+cCLX\nSPiiVtpmFdZnEAp2gS6IV3Y0GpUebU8Z0kgSUrud4Cggp6nFqaMArCpiukbjQTDc\n1Qpeq+t0A1mL0a5jXHofWRJG0QKBgQC7lA2pF5298nPFJBD8qEyqpT1y8hsU1nRN\nL0TWjc7ta9OaD2zPV2C9T53AMxuOYCqVd31z7tUo49Wd/3qu+NFIMRHloOKTjid7\np9A2nHaH5SVZo4XCQUnFpTI2RgdAINtiuaJNNvXALW1XqLai4BIw6d4D1hs/rJAJ\nvhjpE6XIkQKBgQDQB8v2Oju4mlqv0a/XWwdMC0FzlWP4Oyq5DzxUYsKvGJGQ5y8H\nQ+MftN08kYRxtO68Cw4PyZ+GOrM5NaMzURdDyra4fDd8Mlz6yf8UYRVu/WidNo7V\nIRKBo4xJCl/59XQPMeAFHR43eS4OrTGOJJsJ7qpTBTKxjdC0hcqvIU1k8QKBgQCa\nX86eSwFXQiJlLLmONjRifHuGDhqbm6M7optUuICEhSkwsWErgw3qv4tkkqsrEZn6\nSMzGjNiBPoCf95JQThZvA3NnOHFAXs2/xuxlBX/Hd561lw6OQI0mTD52zEtLS79C\nEOSyB3lZIAnNCtzETwSpnM9K+PqT/MDOQ9TcfX8DAQKBgQCAezSLJ2KPuTF6PgKm\nGbM98PDe8gkpbq0OSZMW5+UkcpI88TWobMIvSsMefd227AEo9jK9rrvZfYRZX3+w\nsjIFn3XIwov+DON30n+Yfcti2d4O3olir3S5D2JTXTWgCnAXWbSaxJ0tjjqijRkz\nIX0rDlCXR4dpuANRKaVwuncdag==\n-----END PRIVATE KEY-----\n",
                "client_email": "firebase-adminsdk-bwsfi@neumomeddesarrollo.iam.gserviceaccount.com",
                "client_id": "111261585151349855356",
                "auth_uri": "https://accounts.google.com/o/oauth2/auth",
                "token_uri": "https://oauth2.googleapis.com/token",
                "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
                "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-bwsfi%40neumomeddesarrollo.iam.gserviceaccount.com",
                "databaseURL": "https://neumomeddesarrollo.firebaseio.com",
                "storageBucket": "neumomeddesarrollo.appspot.com",
            };
            firebase.initializeApp(config);
            console.log("database_firebase",firebase)
            const db = firebase.database();

            db.ref('/usuarios')
            .on('child_changed', (data) => {
                console.log("child_changed", data.val(), Math.random())
                this.$store.dispatch('setJsonGestionCambio', Math.random())
                //setTimeout(() => serverBus.$emit('globalConfiguration',jsonClient));
                // return true;
            })
        },
        /**
         * Esta funcion llama al enpoint para hacer la consulta al servidor y traer los datos que pintaran los gráficos (registro y gestión de pacientes).
         * @param {*} endpoint Variable que almacena endpoint para la consulta de los datos
         * @param {*} data Contiene json para consulta (si es modulo 1: programa, filtro_tiempo(horas, dias, meses, años), cantidad)
         */
        obtieneDatosParaGraficar: function(endpoint, data, modulo){
          
          var modulo = modulo;
          var json = data;
          this.displayLoading = true;
          
          if(modulo=="moduloGestion_2"){
            switch(json["estado"]){
                case "no_registrado":
                    endpoint = this.endpointNotRegister;
                    break
                case "registrado":
                    endpoint = this.endpointRegister;
                    break
            }
          }
          //this.datosListosMod1 = false
          //this.datosListosMod2 = false
          console.log("responseQuery0", endpoint, json)
          axios.post(endpoint, json)
            .then(Response => {
                this.displayLoading = false;
                
                //if(Response.data.data["modulo"]=="modulo1"){
                if(Response.data.data["key_grafico"]=="registro"){
                    //let indicadores1 = json_test_mod1.data
                    let indicadores1 = Response.data.data
                    valorPrueba1 = valorPrueba1 + 1
                    this.datacollectionMod1= graficos.contruyeDataCollection(indicadores1,this.datacollectionMod1, valorPrueba1)
                    this.seriesMod1 = this.datacollectionMod1.datasets
                    console.log("terminaConsulta0", this.seriesMod1[0].data)
                    this.datosListosMod1 = true
                }
                //if(Response.data.data["modulo"]=="modulo2"){
                if(Response.data.data["key_grafico"]=="gestion"){
                    
                    //let indicadores2 = json_test_mod2.data
                    let indicadores2 = Response.data.data
                    valorPrueba2 = valorPrueba2 + 1
                    this.datacollectionMod2 = graficos.contruyeDataCollection(indicadores2,this.datacollectionMod2, valorPrueba2)
                    this.seriesMod2 = this.datacollectionMod2.datasets
                    console.log("terminaConsulta1", this.seriesMod2[0].data)
                    this.datosListosMod2 = true
                }

            })
            .catch(error => console.log("error",error), this.displayLoading=false) 
        },

        /**
         * @param {*} endpoint Variable que almacena endpoint para la consulta de los datos (lista de pacientes)
         * @param {*} data Contiene json para consulta (si es modulo 1: programa, filtro(registrados, no-registrados), si es modulo 2: programa, filtro(registrados, no-registrados), pacientes (gestionados, no-gestionados), canal:app,web,google-chat, etc)
         */
        getPatientList:function(endpoint, json){
          this.displayLoading = true;
          console.log("lista",jsonClient)
          if(jsonClient["estado"]=="registrado"){
              endpoint = this.listPatientsMod2_register
          }else{
              endpoint = this.listPatientsMod2_notRegister
          }
          axios.post(endpoint,
            json)
            .then(Response => {
                this.displayLoading = false;
                this.listaPacientes = Response.data.data.modulo_data
                this.displayPopupMessages = true
            })
            .catch(error => console.log("error",error), this.displayLoading=false) 
        }
    },
}
</script>

<style scoped>

#cajaMensajeDinamico, #cajaMensajeDinamico2 {
    background-color:  #ffffff;
    border: 1px solid #cccccc;
    border-radius: 10px;
    margin: 10px auto;
    width: 100%;
    justify-content: center;
    width: 95%;
    height: 3vw;
    padding: 0px 24px 0px 24px;
}
#mensajeDinamico{
    color: #666666;
    font-size: 1.0vw;
    text-align: center;
    font-weight: 400;
}
.content {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    vertical-align: middle;
    margin:0 auto;
}
/* Add a black background color to the top navigation */
.topnav {
 
    overflow: hidden;
    color: white;
    font-family: 'Nunito', sans-serif;
    text-align: center;   
}
center{
    font-size: 1.8vw;
    font-weight: bold;
}
header {
    background-color: #333;
    position: fixed;
    top: 0;
    width: 100%;
}
.grid-container 
{  
    display: grid;  
    height: 100%;  
    width: 100%;
    grid-template-columns: 1fr 1fr;  
    grid-template-rows: 1fr;  
    grid-gap: 1px 1px;  
    grid-template-areas: '. .';
}
.Area-1 { 
    display: none;
    grid-area: 1 / 1 / 2 / 2; 
}
.Area-2 
{
    display: grid;  
    grid-area: 1 / 2 / 2 / 3;  
    grid-template-columns: 1fr;  
    grid-template-rows: 1fr;  
    grid-gap: 1px 1px;  
}
.registerContainer{
    max-width: 90vw;
    max-height: 60vw;
    padding-left: 10%;
}
@media all and (max-width: 840px) {
.grid-container, .topnav {
    margin:0px;
    padding:0px;
    padding-left:5%;
    display:block;
    float:none;
    text-align:left;
}
}
@media screen and (max-device-width : 480px) {
.grid-container, .topnav {
    margin:0px;
    padding:0px;
    padding-left:5%;
    display:block;
    float:none;
    text-align:left;
}
}
</style>



// WEBPACK FOOTER //
// src/components/ControlPanel.vue